import http from '@/http/aisea/axios'
const resource = "/enterprise/vessels/";

export default {
  fetch(vesselId) {
    return http.get(`${resource}${vesselId}/pictures`);
  },

  update(vesselId, linkId, payload) {
    return http.put(`${resource}${vesselId}/pictures${linkId}`, payload);
  },

  linkTo(vesselId, payload) {
    return http.post(`${resource}${vesselId}/pictures`, payload);
  },

  unlinkTo(vesselId, linkId) {
    return http.delete(`${resource}${vesselId}/pictures/${linkId}`);
  },

};
